import config from '../../config.json'


export const AoPartnerBaseUrl = config.AoPartnerBaseUrl
export const AoPartnerBaseUrlMobile = config.AoPartnerBaseUrlMobile
export const AoPartnerBaseUrlDESKTOP = config.COUNTERBASEURLFrontend


let AoUrl ={
    getIpAddressUrlPath: 'https://geolocation-db.com/json/',
    getSubtenantDetailPath: 'api/Subtenant/get-subtenant-details',
    getSeminarUserListPath: 'api/SeminarUserList/getSeminarUserList',
    getPlannerBookingDetailsPath: 'api/PlannerBookings/getPlannerBookings',
    upsertSeminarAttendeePath: 'api/SeminarAttendee/upsertSeminarAttendee',
    // registerWalkInUserPath: 'api/2/User/RegisterWalkInUser',//
    registerWalkInUserPath: 'api/2/User/RegisterWalkInUser',//
    getCountryCodeListPath: 'api/Country/GetRegistrationEnableCountry',
    updateSeminarAttendeeInfoPath: 'api/SeminarAttendee/UpdateSeminarAttendeeStatus',
    getReferenceModePath: 'api/RefereneMode/GetReferenceMode',
    getPlannerCalenderPath: 'api/PlannerCalendar/getPlannerCalendarDetails',//cng
    upsertPlannerBookingPath: 'api/PlannerBookings/upsertPlannerBookings',
    getLoggedInUserPath: "/api/User/GetLoggedInUser/",
    getAthenticatePath: '/api/User/AuthenticateLoggedInUser/',//
    getSeminarPublisherPath: 'api/SeminarPublisher/getSeminar',
    getPlannerStatusUpdatePath :"/api/PlannerBookings/updatePlannerBookingStatus", //current
    // getConfirmationListPath: "/api/PlannerCalendar/getBookedPlannerSlotListWithAttendee/",//////////////
    getConfirmationListPath: "/api/PlannerBookings/GetPlannerBookingList",//////////////
    postBulkRegistration: '/api/User/BulkUserRegister',
    postAddUserOrder:'/api/UserOrder/AddUserOrder',// 
    // postSendPlannerLink: '/api/SeminarAttendee/SendPlannerLink',//
    SendLinkToAttendee: '/api/SeminarAttendee/SendLinkToAttendee/',//
    postregisteraddress:'/api/Address/add-address-by-userid',
    getregaddressbyuserid:'/api/Address/get-address-by-userid/',
    // registerWalkInUserPath: 'api/User/RegisterWalkInUser',
    // registerWalkInUserForInvestPath: 'api/DinnerWithRajiv/RegisterSeminarUser',
    getSeminarPublishePath: 'api/SeminarPublisher/getSeminar',
    getContactDetails: "/api/Contact/get-contact-by-userid/",
    putAPIForMember: "/api/Member/update-member-by-id",
    putAPIForContact: "/api/Contact/update-contact-by-userid/",
    upsertSeminarAttendeeAPI: "/api/SeminarAttendee/upsertSeminarAttendee",
    putAPIForAddress: "/api/Address/update-address",
    putForSheetAlot : "/api/SeminarSeatAllottment/SeatStatus/",
    postCashPayment : "/api/UserOrder/ConfirmUserOrder",
    GetUserRole : "/api/UserRole/GetUserRoleByUserId/",
    GetEmailTemplate : "/api/EmailTemplates/GetEmailTemplates?TemplateId=",
    PostEmailCom : "/api/EmailComm/SendEmailComm",
    userActivation : "/api/UserActivation/GetUserActivationLink",
    getImageBase64: 'api/FileUpload/documents/',

    // ...............................................................................
    getCommMediumPath: '/api/CommMedium/GetCommMedium',
    getTextTemplate: "/api/TextTemplates/GetTextTemplates",
    postSendTextPath: '/api/TextComm/SendText',
    updateUserEmail : '/api/Account/UpdateUserName',
    userActivate11 : '/api/SeminarAttendee/UpdateSeminarAttendeeActiveStatus',
    postClassRoomBooking: 'api/ClassroomBookings/Register',
    putPaymentBookingStatus :  'api/ClassroomBookings/SetPaymentStatus',
    putClassRoomBooking : 'api/ClassroomBookings',
    getClassRoomBooking : 'api/ClassroomBookings',
    getPlannerClassRoomLink : 'api/SeminarAttendeeAccessLink/GetPlannerClassroomLink'




    // ...............................................................................

}

export default AoUrl;


